import { render, staticRenderFns } from "./surface_post_comments.vue?vue&type=template&id=78b53d62&scoped=true&"
import script from "./surface_post_comments.vue?vue&type=script&lang=ts&"
export * from "./surface_post_comments.vue?vue&type=script&lang=ts&"
import style0 from "./surface_post_comments.vue?vue&type=style&index=0&id=78b53d62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b53d62",
  null
  
)

export default component.exports